import React from 'react';
import { Building2, Mail, Phone, MapPin, Shield, Globe, FileText, Calendar } from 'lucide-react';

const MentionsLegales = () => {
  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="container mx-auto px-4 py-12 max-w-8xl">
        {/* En-tête */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Mentions légales</h1>
          <div className="w-24 h-1 bg-blue-600 mx-auto rounded-full"></div>
        </div>

        {/* Éditeur du site */}
        <section className="bg-white rounded-2xl flex flex-col shadow-lg p-8 mb-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="p-3 bg-blue-100 rounded-xl">
              <Building2 className="w-6 h-6 text-blue-600" />
            </div>
            <h2 className="text-2xl font-semibold text-gray-800">Éditeur du site</h2>
          </div>
          
          <div className="prose prose-gray max-w-none">
            <p className="text-gray-600 leading-relaxed mb-4">
              Le présent site internet (<strong className="text-gray-900">pro.tanoed.com</strong>) est édité par <strong className="text-gray-900">SAS TANOED</strong>, 
              une Société par Actions Simplifiée au capital de 1 000 €, immatriculée au Registre du Commerce 
              et des Sociétés de Saint-Denis de La Réunion sous le numéro <strong className="text-gray-900">935 059 899</strong> 
              (SIRET : 935 059 899 00010).
            </p>
            
            <div className="grid gap-3 mt-6 bg-gray-50 p-6 rounded-xl">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-blue-600 mt-0.5" />
                <p className="text-gray-700">
                  <strong>Adresse :</strong> 50 Bis RN2, Immeuble Mangata, 97412 Bras-Panon, La Réunion
                </p>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-blue-600" />
                <p className="text-gray-700">
                  <strong>Email :</strong> <a href="mailto:mangata@tanoed.com" className="text-blue-600 hover:text-blue-800 transition-colors">mangata@tanoed.com</a>
                </p>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-blue-600" />
                <p className="text-gray-700">
                  <strong>Téléphone :</strong> +262 692 26 51 74
                </p>
              </div>
              <div className="flex items-center gap-3">
                <FileText className="w-5 h-5 text-blue-600" />
                <p className="text-gray-700">
                  <strong>Directeur de la publication :</strong> M. Nicky Mangata
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Hébergeur */}
        <section className="bg-white rounded-2xl flex flex-col  shadow-lg p-8 mb-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="p-3 bg-green-100 rounded-xl">
              <Globe className="w-6 h-6 text-green-600" />
            </div>
            <h2 className="text-2xl font-semibold text-gray-800">Hébergeur du site</h2>
          </div>
          
          <div className="prose prose-gray max-w-none">
            <p className="text-gray-600 leading-relaxed mb-4">
              L'hébergement du site est assuré par <strong className="text-gray-900">Scalingo SAS</strong>, Société par Actions Simplifiée 
              au capital de 35 291,90 €, inscrite au RCS sous le SIRET 808 665 483 00018. 
              Siège social : 13 rue Jacques Peirotes, 67000 Strasbourg, France.
            </p>
            
            <div className="bg-green-50 p-6 rounded-xl">
              <p className="text-gray-700 mb-3">
                <strong>Contact hébergeur :</strong> <a href="mailto:support@scalingo.com" className="text-blue-600 hover:text-blue-800 transition-colors">support@scalingo.com</a>
              </p>
              <div className="flex items-start gap-2">
                <Shield className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                <p className="text-gray-700">
                  <strong>À savoir :</strong> Scalingo est un hébergeur certifié <a href="https://scalingo.com/fr/certification-hds" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 transition-colors">HDS</a> 
                  (Hébergeur de Données de Santé), gage de conformité pour l'hébergement de données sensibles.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Propriété intellectuelle */}
        <section className="bg-white rounded-2xl flex flex-col shadow-lg p-8 mb-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="p-3 bg-purple-100 rounded-xl">
              <Shield className="w-6 h-6 text-purple-600" />
            </div>
            <h2 className="text-2xl font-semibold text-gray-800">Propriété intellectuelle</h2>
          </div>
          
          <div className="prose prose-gray max-w-none">
            <p className="text-gray-600 leading-relaxed mb-4">
              L'ensemble du site <strong className="text-gray-900">TANOED</strong>, sa structure générale ainsi que ses contenus 
              (notamment textes, images, illustrations, vidéos, interfaces, logos, éléments graphiques, scripts, bases de données) 
              sont la propriété exclusive de <strong className="text-gray-900">SAS TANOED</strong> et sont protégés par les législations françaises 
              et internationales en vigueur relatives à la propriété intellectuelle.
            </p>
            
            <p className="text-gray-600 leading-relaxed mb-6">
              Toute reproduction, représentation, modification, adaptation, diffusion, distribution ou exploitation 
              partielle ou totale de ces éléments, par quelque moyen que ce soit, sans autorisation écrite préalable 
              de SAS TANOED, est strictement interdite et constituerait une contrefaçon sanctionnée par les articles 
              L.335-2 et suivants du Code de la propriété intellectuelle.
            </p>
            
            <div className="bg-blue-50 border-l-4 border-blue-600 p-6 rounded-r-xl">
              <p className="text-gray-700 mb-3">
                <strong className="text-blue-900">Exception pédagogique :</strong> Les enseignants et personnels de l'Éducation nationale sont autorisés 
                à réaliser et utiliser des captures d'écran de l'interface TANOED à des fins strictement pédagogiques, 
                internes à leur établissement et non commerciales, sous réserve que la source soit clairement mentionnée (« © TANOED »).
              </p>
              <p className="text-gray-700">
                Toute utilisation à des fins commerciales, publicitaires ou externes devra faire l'objet d'une demande 
                d'autorisation écrite préalable à l'adresse suivante : <a href="mailto:mangata@tanoed.com" className="text-blue-600 hover:text-blue-800 transition-colors">mangata@tanoed.com</a>.
              </p>
            </div>
          </div>
        </section>

        {/* Politique de confidentialité */}
        {/* <section className="bg-white rounded-2xl shadow-lg p-8 mb-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="p-3 bg-orange-100 rounded-xl">
              <FileText className="w-6 h-6 text-orange-600" />
            </div>
            <h2 className="text-2xl font-semibold text-gray-800">Politique de confidentialité</h2>
          </div>
          
          <p className="text-gray-600 leading-relaxed">
            Pour en savoir plus sur la gestion des données personnelles et l'utilisation des cookies techniques 
            (access token / refresh token) nécessaires à l'authentification, veuillez consulter notre{' '}
            <a href="/politique-confidentialite" className="text-blue-600 hover:text-blue-800 font-medium transition-colors">
              Politique de confidentialité
            </a>.
          </p>
        </section> */}

        {/* Pied de page */}
        <div className="text-center mt-12">
          <div className="flex items-center justify-center gap-2 text-gray-500">
            <Calendar className="w-4 h-4" />
            <p className="text-sm">
              <strong>Dernière mise à jour :</strong> Juillet 2025
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegales;